export var SMS_ERROR = /* @__PURE__ */ ((SMS_ERROR2) => {
  SMS_ERROR2["CAN_NOT_SEND"] = "can_not_send";
  SMS_ERROR2["INVALID_RECEIVER_NUMBER"] = "invalid_receiver_number";
  SMS_ERROR2["INVALID_SENDER_NUMBER"] = "invalid_sender_number";
  SMS_ERROR2["MESSAGE_TOO_LARGE"] = "message_too_large";
  SMS_ERROR2["RECEIVER_UNSUBSCRIBED"] = "receiver_unsubscribed";
  SMS_ERROR2["CARRIER_ERROR"] = "carrier_error";
  SMS_ERROR2["SPAM_BLOCK"] = "spam_block";
  SMS_ERROR2["SENDER_HAS_NO_CREDIT"] = "sender_has_no_credit";
  SMS_ERROR2["RECEIVER_HAS_NO_CREDIT"] = "receiver_has_no_credit";
  SMS_ERROR2["INCORRECT_CREDENTIALS"] = "incorrect_credentials";
  SMS_ERROR2["SERVICE_ERROR"] = "service_error";
  return SMS_ERROR2;
})(SMS_ERROR || {});
export const HARD_SMS_ERRORS = /* @__PURE__ */ new Set([
  "message_too_large" /* MESSAGE_TOO_LARGE */,
  "invalid_sender_number" /* INVALID_SENDER_NUMBER */,
  "sender_has_no_credit" /* SENDER_HAS_NO_CREDIT */,
  "incorrect_credentials" /* INCORRECT_CREDENTIALS */
]);
export const SUCCESS_SMS_ERRORS = /* @__PURE__ */ new Set([
  "spam_block" /* SPAM_BLOCK */
]);
export const SERVICE_SMS_ERRORS = /* @__PURE__ */ new Set([
  "service_error" /* SERVICE_ERROR */
]);
export const HARD_SMS_ERRORS_MINIMUM_THRESHOLD = {
  ["invalid_sender_number" /* INVALID_SENDER_NUMBER */]: 16
};
